angular.module('tasks')
    .component('dashboardNewTask', {
        templateUrl: 'app/task/dashboard-new-task.html',
        controller: function ($rootScope, toastr, Task, TaskService) {
            this.TaskService = TaskService

            this.$onInit = () => {
                this.newTaskTopic = ""
            }

            this.addSimpleTask = () => {
                let task = {
                    id: null,
                    priority: "LOW",
                    status: "SCHEDULED",
                    sendNotifications: false,
                    topic: this.newTaskTopic
                }
                Task.save(task).$promise.then(() => {
                    this.newTaskTopic = ""
                    $rootScope.$broadcast('task.updated')
                    toastr.success("Zapisano")
                })
            }
        }
    })
